import useGetStatusTag from '~/hooks/srp/useGetStatusTag';
import OnHoldTag from './OnHoldTag';
import { Tag, tagColorMap, tagTextMap } from '../constants';
import { StatusTagWrapper } from '../Tags.styles';

export default function StatusTag() {
  const tag = useGetStatusTag();

  return tag ? (
    <div className="absolute flex left-0 top-0">
      {tag === Tag.Hold ? (
        <OnHoldTag />
      ) : (
        <StatusTagWrapper
          className={tagColorMap[tag]}
          data-qa={`text-only-${tag}`}
        >
          {tagTextMap[tag]}
        </StatusTagWrapper>
      )}
    </div>
  ) : null;
}
